import {Modal} from 'bootstrap';
import {Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, OnDestroy} from '@angular/core';
import {IsFilterOnService} from '../../../../Services/is-filter-on.service';
import {TypeaheadBase} from '../../../common/typeahead/typeahead-base';
@Component({
  selector: 'app-batch-select',
  templateUrl: './batch-select.component.html',
  styleUrls: ['./batch-select.component.css'],
  standalone: false
})
export class BatchSelectComponent extends TypeaheadBase implements OnInit, OnDestroy {
  @ViewChild('closeButton') closeButton: ElementRef;

  @Input() vm: any;

  @Output() testBatchEmit = new EventEmitter<string>();
  @Output() updateBatchEmit = new EventEmitter<string>();
  @Output() selectBatchEmit = new EventEmitter<string>();
  public detail = {id: null};
  batchTypeaheadSearch = (text$: any) => this.typeaheadSearch(text$, () => this.vm?.batchName, 10);

  constructor(public isFiltered: IsFilterOnService) {
    super();
  }

  ngOnInit() {
  }

  testBatch() {
    this.testBatchEmit.emit();
  }

  updateBatch() {
    this.updateBatchEmit.emit();
  }

  selectBatch(batchId) {
    // $('#batchSelect').modal('hide');
    this.selectBatchEmit.emit(batchId);
  }

  checkFiltered(): boolean {
    const filteredValue = this.isFiltered.isFiltered(this.vm);
    this.vm.filtered = filteredValue;
    return filteredValue;
  }
  ngOnDestroy() {
    const modalEl = this.closeButton?.nativeElement?.closest('.modal');
    if (modalEl) {
      const modal = Modal.getInstance(modalEl);
      if (modal) {
        modal.hide();
      }
    }
  }

}
